var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"card-map",attrs:{"title":"Google Maps"}},[_c('div',{staticClass:"map"},[_c('div',{attrs:{"id":"map"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }